const PENDING = "Pending";
const PENDING_REVIEW = "Pending Review";
const UNDER_REVIEW = "Under Review";
const UNVERIFIED = "Unverified";
const INCOMPLETE = "Incomplete";
const FAILED = "Failed";
const FAILED_VERIFICATION = "Failed Verification";
const VERIFIED = "Verified";
const COMPLETE = "Complete";
export const PROCESSING = "processing";

export const KEY_NULL = "Null";
export const KEY_NONE = "None";
export const KEY_PROGRESS = "In progress";
export const KEY_FAILED = "Failed";
export const KEY_APPROVED = "Verified";

export const getVerificationStatusKeyAndFlag = (data, isId = false) => {
    if (!data.document && data.verificationStatus === UNVERIFIED) {
        return {
            key: KEY_NONE,
            statusTextKey: isId ? "status.IDUnverified" : "status.unverified",
            isWarning: true,
        };
    }
    if (!data.document && data.verificationStatus === INCOMPLETE) {
        return {
            key: KEY_NONE,
            statusTextKey: "status.incomplete",
            isWarning: true,
        };
    }
    if (data.document && data.verificationStatus === UNVERIFIED) {
        return {
            key: KEY_PROGRESS,
            statusTextKey: "status.verifying",
            isInfo: true,
        };
    }
    if (data.verificationStatus === PENDING || data.verificationStatus === PENDING_REVIEW) {
        return {
            key: KEY_PROGRESS,
            statusTextKey: "status.verifying",
            isInfo: true,
        };
    }
    if (data.verificationStatus === UNDER_REVIEW) {
        return {
            key: KEY_PROGRESS,
            statusTextKey: "status.underReview",
            isInfo: true,
        };
    }
    if (data.verificationStatus === FAILED || data.verificationStatus === FAILED_VERIFICATION) {
        return {
            key: KEY_FAILED,
            statusTextKey: "status.failed",
            isWarning: true,
        };
    }
    if (data.verificationStatus === VERIFIED || data.verificationStatus === COMPLETE) {
        return {
            key: KEY_APPROVED,
            statusTextKey: isId ? "status.approved" : "status.complete",
            isSuccess: true,
        };
    }

    return {
        key: KEY_NULL,
        statusTextKey: "status.incomplete",
        isWarning: true,
    };
};
